export default "__VITE_ASSET__95b65431__"